export default __webpack_public_path__ + "static/media/Xplir_logo_icon.f5f23fa6.svg";